import React, { useCallback } from 'react';
import { INotificationEntity, Routes } from 'types';
import { useStyles } from './StatusSection.styles';
import { useNavigate } from 'react-router';
import { useRouteParams } from 'app/shared/hooks/useRouteParams';
import NotificationSettingsIcon from 'assets/settings.svg?react';
import { themeColors } from 'app/shared/theme';
import { getNotificationSettingsTab } from 'app/shared/utils';

interface IStatusSectionProps {
  notificationEntityBaseModel: INotificationEntity | null;
}

export const StatusSection = ({
  notificationEntityBaseModel,
}: IStatusSectionProps) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const {
    organizationId,
    entityType,
  }: { organizationId: string; entityType: string } = useRouteParams();
  const notificationSettingsClickHandler = useCallback(
    (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      localStorage.setItem(
        Number(entityType).toString(),
        JSON.stringify(notificationEntityBaseModel),
      );

      navigate(
        Routes.NotificationSettings.replace(
          ':organizationId/:tab/:page/:perPage/:alternativePage/:alternativePerPage',
          `${organizationId}/${getNotificationSettingsTab(
            Number(entityType),
          )}/1/20/1/20`,
        ),
      );
    },
    [navigate, notificationEntityBaseModel, organizationId, entityType],
  );

  return (
    <div className={classes.projectCardHeader}>
      <NotificationSettingsIcon
        stroke={themeColors.mbsBlue}
        className={classes.sentNotificationsLink}
        onClick={notificationSettingsClickHandler}
      />
    </div>
  );
};
